import "./partner.css";

const Partner = () =>{

    const handleScroll = (id) => {
        const element = document.getElementById(id);
        if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "nearest" });
        }
    };

    return(
        <div className="spoon-shape-partner">
            {/* left content div */}
            <div className="contentt-div">
                <div className="content-main">
                    <span className="vision-2">Partner <br className="next-line" /> <span className="vision-text-2">with us & streamline your customer onboarding</span></span>
                    <span className="vision-3">At BeFiSc, we are committed to your growth by providing the tools necessary to build trust and integrity with your customer base. Partner with us to enhance your onboarding processes and safeguard your business against potential risks.</span>
                </div>

                <button className="book-buton" onClick={() => handleScroll("book-a-demo")}>Book a Demo & Get Started</button>
            </div>

            {/* right image div */}
            <div className="image-div">
                <img src="https://befisc-website-assets.s3.ap-south-1.amazonaws.com/assets/Image.svg
" className="image-size" />
            </div>

        </div>
    )
}

export default Partner;